export function formatPhoneNumber(inputValue: string): string {
  if (!inputValue) return '';

  const cleaned = inputValue.replace(/\D/g, '');

  const phoneWithoutCountryCode = cleaned.startsWith('998')
    ? cleaned.slice(3)
    : cleaned;
  const phone9Digit = phoneWithoutCountryCode.slice(-9);

  const match = phone9Digit.match(/^(\d{2})(\d{3})(\d{2})(\d{2})$/);
  if (match) {
    return `+998 ${match[1]} ${match[2]} ${match[3]}${match[4]}`;
  }

  return inputValue;
}
export function toTelHref(inputValue: string): string {
  const cleaned = inputValue.replace(/\D/g, '');
  return cleaned ? `tel:+${cleaned}` : '';
}

export function formatPhoneNumberWithCode(inputValue: string): string {
  if (!inputValue) return '';

  const cleaned = inputValue.replace(/\D/g, '');

  const phoneWithoutCountryCode = cleaned.startsWith('998')
    ? cleaned.slice(3)
    : cleaned;
  const phone9Digit = phoneWithoutCountryCode.slice(-9);

  const match = phone9Digit.match(/^(\d{2})(\d{3})(\d{2})(\d{2})$/);
  if (match) {
    return `+ 998 (${match[1]}) ${match[2]}-${match[3]}-${match[4]}`;
  }

  return inputValue;
}

/**
 * Номер в том виде, которого ждёт `client/otp-auth`: `998XXXXXXXXX`, без плюса
 * и пробелов. Поле формы хранит девять цифр (см. PhoneField), но сюда номер
 * приходит и из других мест — принимаем любой формат и оставляем цифры.
 */
export function toApiPhone(inputValue: string): string {
  const digits = inputValue.replace(/\D/g, '');

  return digits.startsWith('998') ? digits : `998${digits.slice(-9)}`;
}
